import React, { Fragment } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import ResizeDetector from 'react-resize-detector';
import cx from 'classnames';
import { useSelector } from 'react-redux';

import Routes from './router/Routes';
import './App.css';

function App() {
  const {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    closedSmallerSidebar,
    enableMobileMenu,
    enablePageTabsAlt,
    enableClosedSidebar,
  } = useSelector((state) => state.ThemeOptions);

  return (
    <ResizeDetector
      handleWidth
      render={({ width }) => (
        <Fragment>
          <Router>
            <div className={cx(
              `app-container app-theme-${colorScheme}`,
              { 'fixed-header': enableFixedHeader },
              { 'fixed-sidebar': enableFixedSidebar || width < 1250 },
              { 'fixed-footer': enableFixedFooter },
              { 'closed-sidebar': true },
              { 'closed-sidebar-mobile': closedSmallerSidebar || width < 1250 },
              { 'sidebar-mobile-open': enableMobileMenu },
              { 'body-tabs-shadow-btn': enablePageTabsAlt },
            )}>
              <Routes />
            </div>
          </Router>
        </Fragment>
      )}
    />
  );
}

export default App;
